import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { pills as Pills } from '@breezeway/brzw-components';
import { taskHelper } from '@common/utils';

import './badge_manager.scss';

const {
  getLifeStatus,
  getPausedStatus,
  getTypeStatusCode,
  getTypeStatusName,
  isDraft,
  SINGLE_TASK_LIFE_STATUS,
  TASK_ASSIGNMENT_STATUS,
  TASK_TYPE_STATUS,
} = taskHelper;

export const CLASS_NAME = 'badge-manager';

const BadgeManager = ({ task, className }) => {
  const isTaskADraft = isDraft(task);
  const lifeStatus = getLifeStatus(task);
  const isPaused = getPausedStatus(task);
  const typeStatus = getTypeStatusCode(task);
  let text = getTypeStatusName(task);
  let theme = null;
  let iconNameRight = null;

  if (isPaused) {
    iconNameRight = 'pause';
  }

  if (
    lifeStatus === SINGLE_TASK_LIFE_STATUS.OVERDUE ||
    typeStatus === TASK_ASSIGNMENT_STATUS.DECLINED ||
    typeStatus === TASK_ASSIGNMENT_STATUS.EXPIRED
  ) {
    if (typeStatus === TASK_TYPE_STATUS.CREATED) {
      text = 'Overdue';
    }

    theme = 'overdue';
  } else if (isTaskADraft) {
    text = 'Draft';
    theme = null;
  } else if (typeStatus === TASK_TYPE_STATUS.CREATED) {
    return null;
  } else if (lifeStatus === SINGLE_TASK_LIFE_STATUS.IN_PROGRESS) {
    if (!isPaused) {
      iconNameRight = 'play';
    }
    theme = 'in-progress';
  } else if (lifeStatus === SINGLE_TASK_LIFE_STATUS.UNASSIGNED) {
    theme = 'unassigned';
  } else if (
    lifeStatus === SINGLE_TASK_LIFE_STATUS.ASSIGNED ||
    typeStatus === TASK_ASSIGNMENT_STATUS.ACCEPTED
  ) {
    theme = 'assigned';
  } else if (typeStatus === TASK_ASSIGNMENT_STATUS.PENDING) {
    theme = 'pending';
  } else if (
    lifeStatus === SINGLE_TASK_LIFE_STATUS.FINISHED ||
    typeStatus === TASK_TYPE_STATUS.CLOSED
  ) {
    theme = 'finished';
  } else if (lifeStatus === SINGLE_TASK_LIFE_STATUS.APPROVED) {
    theme = 'approved';
  }

  return (
    <Pills.PillToggle
      alignIcon="left"
      className={classnames(CLASS_NAME, className, {
        [`${CLASS_NAME}--${theme}`]: theme,
      })}
      disabled
      icon={iconNameRight}
      text={text}
    />
  );
};

BadgeManager.propTypes = {
  className: PropTypes.string,
  task: PropTypes.shape({
    draft: PropTypes.bool,
    paused: PropTypes.bool,
    start_date: PropTypes.string,
    type_task_status: PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.string,
    }),
  }),
};

BadgeManager.defaultProps = {
  task: {},
};

export default BadgeManager;
